export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[700px] mx-auto text-center">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2">投稿合作</h2>
        <p className="text-sm text-foreground-400 mb-8">有优质影视资源或内容合作意向？欢迎联系我们</p>
        <div className="bg-background-100 rounded-xl p-6 md:p-8">
          <div className="w-14 h-14 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4">
            <i className="ri-mail-send-line text-primary-600 text-2xl"></i>
          </div>
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-3">商务合作与内容投稿</h3>
          <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-[480px] mx-auto">
            桃花视频欢迎各大影视平台、内容创作者和版权方洽谈合作。
            如有优质资源推荐、内容合作或广告投放需求，请通过以下方式联系我们。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="mailto:contact@taohua.example.com"
              className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>发送邮件
            </a>
            <a
              href="#about"
              className="px-6 py-2.5 bg-background-50 hover:bg-background-200 border border-background-300 text-foreground-700 text-sm font-medium rounded-lg whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-information-line mr-2"></i>了解更多
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}